import axios from "@/libs/api.request";

export const getCategory = params => {
  return axios.request({
    url: "/warehouse/cargoCategory",
    method: "get",
    params
  });
};
export const getDetails = id => {
  return axios.request({
    url: `/warehouse/cargoCategory/${id}`,
    method: "GET"
  });
};
export const del = id => {
  return axios.request({
    url: `/warehouse/cargoCategory/${id}`,
    method: "DELETE"
  });
};
export const update = data => {
  return axios.request({
    url: `/warehouse/cargoCategory/${data.id}`,
    method: "PUT",
    data
  });
};
export const add = data => {
  return axios.request({
    url: "/warehouse/cargoCategory",
    method: "POST",
    data
  });
};

export const getCountryCategory = params => {
  return axios.request({
    url: "/warehouse/cargoCategory/getList",
    method: "get",
    params
  });
};

export const getB2bCategory = id => {
  return axios.request({
    url: `/common/category/${id}`,
    method: "get"
  });
};

// 开关
export const getSwitch = id => {
  return axios.request({
    url: `/warehouse/cargoCategory/status/${id}`,
    method: "POST"
  });
};
